(function () {
  var KEY = 'blore-foods-wishlist';

  function getIds() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveIds(ids) {
    localStorage.setItem(KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { ids: ids } }));
  }

  function toggle(id) {
    var ids = getIds().map(String);
    var key = String(id);
    var index = ids.indexOf(key);
    if (index > -1) {
      ids.splice(index, 1);
    } else {
      ids.push(key);
    }
    saveIds(ids);
  }

  function updateToggleButtons(ids) {
    var idSet = ids.map(String);
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var active = idSet.indexOf(String(button.dataset.productId)) > -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }

  function updateCountBadge(ids) {
    var badge = document.querySelector('[data-wishlist-count]');
    if (!badge) return;
    badge.textContent = ids.length;
    badge.hidden = ids.length === 0;
  }

  function isWishlistView() {
    return new URLSearchParams(window.location.search).get('view') === 'wishlist';
  }

  function applyWishlistViewFilter(ids) {
    if (!isWishlistView()) return;

    var cards = document.querySelectorAll('[data-product-card]');
    if (!cards.length) return;

    var idSet = ids.map(String);
    var grid = cards[0].closest('[data-shop-grid]') || cards[0].parentElement;
    var empty = document.querySelector('[data-shop-empty]');
    var visibleCount = 0;

    cards.forEach(function (card) {
      var match = idSet.indexOf(String(card.dataset.productId)) > -1;
      card.hidden = !match;
      card.style.display = match ? '' : 'none';
      if (match) visibleCount += 1;
    });

    if (grid) grid.hidden = visibleCount === 0;
    if (empty) empty.hidden = visibleCount > 0;

    var heading = document.querySelector('[data-collection-heading]');
    var subheading = document.querySelector('[data-collection-subheading]');
    if (heading) heading.textContent = 'Your wishlist';
    if (subheading) subheading.textContent = 'Products you have saved for later.';
  }

  function refresh() {
    var ids = getIds().map(String);
    updateToggleButtons(ids);
    updateCountBadge(ids);
    applyWishlistViewFilter(ids);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('wishlist:updated', refresh);
  document.addEventListener('shop:filtered', refresh);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button.dataset.productId);
  });
})();
